export function isOfferCardCarouselFilterSelectionValid(
  selectedFilter: string | undefined,
  filterOptions: Array<{ value: string | number }>,
): boolean {
  return !!selectedFilter && filterOptions.some(option => String(option.value) === selectedFilter)
}

export function shouldResetOfferCardCarouselSelection(
  selectedFilter: string | undefined,
  filterOptions: Array<{ value: string | number }>,
): boolean {
  if (!selectedFilter) {
    return false
  }

  return !isOfferCardCarouselFilterSelectionValid(selectedFilter, filterOptions)
}
